import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "574c6386-b95d-467a-8247-072a27871ed8" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#574c6386-b95d-467a-8247-072a27871ed8)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 345h512v167H0z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ a({
  __name: "nl",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=nl-6b43d432.js.map
